/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as DefaultRouteImport } from './routes/_default'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as DefaultIndexRouteImport } from './routes/_default/index'
import { Route as OnboardingCreateWorkspaceRouteImport } from './routes/onboarding/create-workspace'
import { Route as DefaultTasksRouteImport } from './routes/_default/tasks'
import { Route as DefaultSettingsRouteImport } from './routes/_default/settings'
import { Route as DefaultProjectsRouteImport } from './routes/_default/projects'
import { Route as DefaultProfileRouteImport } from './routes/_default/profile'
import { Route as DefaultFormsRouteImport } from './routes/_default/forms'
import { Route as DefaultContractsRouteImport } from './routes/_default/contracts'
import { Route as DefaultCalendarRouteImport } from './routes/_default/calendar'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const DefaultRoute = DefaultRouteImport.update({
  id: '/_default',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DefaultIndexRoute = DefaultIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/index.lazy').then((d) => d.Route),
)
const OnboardingCreateWorkspaceRoute =
  OnboardingCreateWorkspaceRouteImport.update({
    id: '/create-workspace',
    path: '/create-workspace',
    getParentRoute: () => OnboardingRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/create-workspace.lazy').then((d) => d.Route),
  )
const DefaultTasksRoute = DefaultTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/tasks.lazy').then((d) => d.Route),
)
const DefaultSettingsRoute = DefaultSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/settings.lazy').then((d) => d.Route),
)
const DefaultProjectsRoute = DefaultProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/projects.lazy').then((d) => d.Route),
)
const DefaultProfileRoute = DefaultProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/profile.lazy').then((d) => d.Route),
)
const DefaultFormsRoute = DefaultFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/forms.lazy').then((d) => d.Route),
)
const DefaultContractsRoute = DefaultContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/contracts.lazy').then((d) => d.Route),
)
const DefaultCalendarRoute = DefaultCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DefaultRoute,
} as any).lazy(() =>
  import('./routes/_default/calendar.lazy').then((d) => d.Route),
)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/register.lazy').then((d) => d.Route),
)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/login.lazy').then((d) => d.Route))
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/calendar': typeof DefaultCalendarRoute
  '/contracts': typeof DefaultContractsRoute
  '/forms': typeof DefaultFormsRoute
  '/profile': typeof DefaultProfileRoute
  '/projects': typeof DefaultProjectsRoute
  '/settings': typeof DefaultSettingsRoute
  '/tasks': typeof DefaultTasksRoute
  '/onboarding/create-workspace': typeof OnboardingCreateWorkspaceRoute
  '/': typeof DefaultIndexRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/calendar': typeof DefaultCalendarRoute
  '/contracts': typeof DefaultContractsRoute
  '/forms': typeof DefaultFormsRoute
  '/profile': typeof DefaultProfileRoute
  '/projects': typeof DefaultProjectsRoute
  '/settings': typeof DefaultSettingsRoute
  '/tasks': typeof DefaultTasksRoute
  '/onboarding/create-workspace': typeof OnboardingCreateWorkspaceRoute
  '/': typeof DefaultIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_default': typeof DefaultRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_default/calendar': typeof DefaultCalendarRoute
  '/_default/contracts': typeof DefaultContractsRoute
  '/_default/forms': typeof DefaultFormsRoute
  '/_default/profile': typeof DefaultProfileRoute
  '/_default/projects': typeof DefaultProjectsRoute
  '/_default/settings': typeof DefaultSettingsRoute
  '/_default/tasks': typeof DefaultTasksRoute
  '/onboarding/create-workspace': typeof OnboardingCreateWorkspaceRoute
  '/_default/': typeof DefaultIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/calendar'
    | '/contracts'
    | '/forms'
    | '/profile'
    | '/projects'
    | '/settings'
    | '/tasks'
    | '/onboarding/create-workspace'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/calendar'
    | '/contracts'
    | '/forms'
    | '/profile'
    | '/projects'
    | '/settings'
    | '/tasks'
    | '/onboarding/create-workspace'
    | '/'
  id:
    | '__root__'
    | '/_auth'
    | '/_default'
    | '/onboarding'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_default/calendar'
    | '/_default/contracts'
    | '/_default/forms'
    | '/_default/profile'
    | '/_default/projects'
    | '/_default/settings'
    | '/_default/tasks'
    | '/onboarding/create-workspace'
    | '/_default/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DefaultRoute: typeof DefaultRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_default': {
      id: '/_default'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DefaultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_default/': {
      id: '/_default/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DefaultIndexRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/onboarding/create-workspace': {
      id: '/onboarding/create-workspace'
      path: '/create-workspace'
      fullPath: '/onboarding/create-workspace'
      preLoaderRoute: typeof OnboardingCreateWorkspaceRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_default/tasks': {
      id: '/_default/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof DefaultTasksRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/settings': {
      id: '/_default/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DefaultSettingsRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/projects': {
      id: '/_default/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof DefaultProjectsRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/profile': {
      id: '/_default/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DefaultProfileRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/forms': {
      id: '/_default/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof DefaultFormsRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/contracts': {
      id: '/_default/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof DefaultContractsRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_default/calendar': {
      id: '/_default/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof DefaultCalendarRouteImport
      parentRoute: typeof DefaultRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DefaultRouteChildren {
  DefaultCalendarRoute: typeof DefaultCalendarRoute
  DefaultContractsRoute: typeof DefaultContractsRoute
  DefaultFormsRoute: typeof DefaultFormsRoute
  DefaultProfileRoute: typeof DefaultProfileRoute
  DefaultProjectsRoute: typeof DefaultProjectsRoute
  DefaultSettingsRoute: typeof DefaultSettingsRoute
  DefaultTasksRoute: typeof DefaultTasksRoute
  DefaultIndexRoute: typeof DefaultIndexRoute
}

const DefaultRouteChildren: DefaultRouteChildren = {
  DefaultCalendarRoute: DefaultCalendarRoute,
  DefaultContractsRoute: DefaultContractsRoute,
  DefaultFormsRoute: DefaultFormsRoute,
  DefaultProfileRoute: DefaultProfileRoute,
  DefaultProjectsRoute: DefaultProjectsRoute,
  DefaultSettingsRoute: DefaultSettingsRoute,
  DefaultTasksRoute: DefaultTasksRoute,
  DefaultIndexRoute: DefaultIndexRoute,
}

const DefaultRouteWithChildren =
  DefaultRoute._addFileChildren(DefaultRouteChildren)

interface OnboardingRouteChildren {
  OnboardingCreateWorkspaceRoute: typeof OnboardingCreateWorkspaceRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingCreateWorkspaceRoute: OnboardingCreateWorkspaceRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DefaultRoute: DefaultRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
